import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';

import isValidProp from '@emotion/is-prop-valid';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { NatterThemeProvider } from 'common/hocs';
import { logEnabledFeatures } from 'common/utils';
import { MotionConfig } from 'framer-motion';
import { AuthProvider } from 'modules/authorization';
import { KeycloakProvider } from 'modules/keycloak/context';
import { createRoot } from 'react-dom/client';
import { reduxHistory } from 'reduxHistory';
import { store } from 'store';

import { initDatadogLogs } from './datadog-logs';
import { initDatadogRum } from './datadog-rum';
import i18n from './i18n';
import './index.css';
import { initBrowserMsw } from './mocks/initBrowserMsw';
import { PreApp } from './preApp';
import { initSentry } from './sentry';

initSentry();
initDatadogRum();
initDatadogLogs();
initBrowserMsw();
logEnabledFeatures();

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <I18nextProvider i18n={i18n}>
    <Router history={reduxHistory}>
      <StyledEngineProvider injectFirst>
        <MotionConfig reducedMotion="user" isValidProp={isValidProp}>
          <NatterThemeProvider>
            <CssBaseline />
            <AuthProvider>
              <KeycloakProvider>
                <Provider store={store}>
                  <PreApp />
                </Provider>
              </KeycloakProvider>
            </AuthProvider>
          </NatterThemeProvider>
        </MotionConfig>
      </StyledEngineProvider>
    </Router>
  </I18nextProvider>
);
